module.exports = __webpack_public_path__ + "img/close_button.5885a.png";